
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2 9.78334V14.2278C2 14.8389 2.5 15.3389 3.11111 15.3389H6.44444L11.0556 19.95C11.4 20.2945 12 20.05 12 19.5611V4.46112C12 3.96112 11.4 3.71668 11.0556 4.07223L6.44444 8.68334H3.11111C2.5 8.68334 2 9.18334 2 9.79445V9.78334ZM17 12.0056C17 10.0389 15.8667 8.35001 14.2222 7.52779V16.4722C15.8667 15.6611 17 13.9722 17 12.0056ZM14.2222 3.61668V3.82779C14.2222 4.25001 14.5 4.61668 14.9 4.77223C17.7556 5.91668 19.7778 8.71667 19.7778 11.9945C19.7778 15.2722 17.7556 18.0611 14.9 19.2167C14.5 19.3722 14.2222 19.7389 14.2222 20.1611V20.3722C14.2222 21.0722 14.9222 21.5722 15.5778 21.3278C19.3333 19.8945 22 16.25 22 11.9945C22 7.7389 19.3333 4.10556 15.5778 2.67223C14.9222 2.42779 14.2222 2.92779 14.2222 3.62779V3.61668Z","fill":"#16171F"}})])
          )
        }
      }
    